import { RouterProvider } from "react-router-dom";
import About from "./components/About";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Work from "./components/Work";
import router from "./Route/Route";



function App() {

  return (
    <div  className=" bg-[#0a192f]">
    <RouterProvider router = {router} ></RouterProvider>
    </div>
  );
}

export default App;
